import React from 'react';

const Payment = () => {
    return (
        <div>
            <h2>payment gateway will be coming soon !</h2>
        </div>
    );
};

export default Payment;